export enum FieldError {
  required = 'required',
  pattern = 'pattern',
  min = 'min',
  max = 'max',
  minDate = 'minDate',
  maxDate = 'maxDate',
  channelUnlinked = 'channelUnlinked',
}
